import styled from 'styled-components';
import NameChangeSvg from '../../assets/mytrips/name-change.svg';

const NameChangeIcon = styled(NameChangeSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '21rem'};
  height: ${props => props.height || '11.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default NameChangeIcon;
